export enum CaseBattlePhases {
    INITIALIZE = 'initialize',
    ROUND = 'round',
    RAFFLE = 'raffle',
    VICTORY = 'victory',
}
export enum CaseBattleLists {
    HISTORY_GAMES = 'history',
    ACTIVE_GAMES = 'active',
}